import { MDText } from 'i18n-react';

import { formatText } from 'Utilities/formatters';

import MetaTexts from './getMetaTags.texts';
import type { VehicleData } from './vehicle.schema';

const LocalT = new MDText(MetaTexts);

interface GetMetaTitleParams {
	make: VehicleData['mainInfo']['make'];
	model: VehicleData['mainInfo']['model'];
	prettyVrm: VehicleData['mainInfo']['prettyVrm'];
	year: VehicleData['mainInfo']['year'];
}

interface GetMetaDescriptionParams {
	fuel: VehicleData['mainInfo']['fuel'];
	mileage: VehicleData['mainInfo']['mileage'];
	transmission: VehicleData['mainInfo']['transmission'];
}

const defaultTitle = LocalT.translate('title');
const defaultDescription = LocalT.translate('description');

const invalidVehicleMeta = {
	description: defaultDescription,
	title: defaultTitle,
};

const getMetaTitle = ({ make, model, prettyVrm, year }: GetMetaTitleParams) => {
	return `${prettyVrm} - ${make} ${model} (${year}) | Motorway`;
};

const getMetaDescription = ({ fuel, mileage, transmission }: GetMetaDescriptionParams) => {
	return LocalT.translate('fullDescription', {
		fuel,
		mileage: formatText(mileage),
		transmission,
	});
};

export const getMetaTags = (vehicle: Nullable<VehicleData>) => {
	if (!vehicle) {
		return invalidVehicleMeta;
	}

	const {
		mainInfo: { fuel, make, mileage, model, prettyVrm, transmission, year },
	} = vehicle;

	return {
		description: getMetaDescription({ fuel, mileage, transmission }),
		title: getMetaTitle({ make, model, prettyVrm, year }),
	};
};
